import * as React from 'react';
import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger, { Logger } from '@wix/bi-logger-contacts';

const BiLoggerContext = React.createContext<Logger>(null as any);

export function BiLoggerProvider({ msid, children }) {
  const { current: logger } = React.useRef<Logger>(
    initSchemaLogger(webBiLogger)(),
  );
  React.useEffect(() => {
    logger.util.updateDefaults({
      msid,
    });
  }, [msid]);

  return (
    <BiLoggerContext.Provider value={logger}>
      {children}
    </BiLoggerContext.Provider>
  );
}

export const useBiLogger = (): Logger => React.useContext(BiLoggerContext);
